export const FINAL_STATUSES = ["COMPLETED","CANCELLED", "DENIED", "EXPIRED"]

export const TRANSITION_STATUSES = [
    'ACCEPTED',
    'PREPARING',
    'READY'
]
export const STATUS = [
    'ACKNOWLEDGE',
    'RECEIVED',
    ...TRANSITION_STATUSES,
    ...FINAL_STATUSES
]


export function isStatusBefore(status, before){
    return STATUS.indexOf(status) < STATUS.indexOf(before);
}

export function isStatusAfter(status, after){
    return STATUS.indexOf(status) > STATUS.indexOf(after);
}

export function isStatusAtLeast(status, atLeast){
    return STATUS.indexOf(status) >= STATUS.indexOf(atLeast);
}
